<template>
	<div class="content">
		<div class="info">
			<div class="backgo" @click="back()"><img src="../../assets/img/back.png" alt=""><div>返回</div></div>
			<div class="cont_title">作业列表</div>
			<div class="wrap">
				 <el-input style="width: 380px;" v-model="queryParams.task_name"  placeholder="2020请输入综合作业标题" type="text"/>
				 <div class="top_rig"  v-if="id">
				 	<div class="zujuan_btn btn1" @click="opendio()">
				 		<img src="../../assets/img/tea2.png" alt="">
				 		<div>添加试题</div>
				 	</div>
				 </div>
			</div>
			<el-form  ref="form" style="margin-top: 35px;" :model="queryParams" label-width="58px">
				<el-row>
					<el-col :span="5" style="margin-right: 20px;">
						<el-form-item label="单选">
						  <el-input v-model="queryParams.task_danxuan_code" placeholder="请输入题目分数" type="text"/>
						</el-form-item>
					</el-col>
					<el-col :span="5" style="margin-right: 20px;">
						<el-form-item label="多选" prop="newpsw">
						   <el-input v-model="queryParams.task_duoxuan_code" placeholder="请输入题目分数" type="text"/>
						</el-form-item>
					</el-col>
					<el-col :span="5" style="margin-right: 20px;">
						<el-form-item label="判断">
						  <el-input v-model="queryParams.task_panduan_code" placeholder="请输入题目分数" type="text"/>
						</el-form-item>
					</el-col>
					<el-col :span="5" style="margin-right: 20px;">
						<el-form-item label="应用">
						   <el-input v-model="queryParams.task_yingyong_code" placeholder="请输入题目分数" type="text"/>
						</el-form-item>
					</el-col>
					<el-button type="primary" @click="taskbian()">确 定</el-button>
				</el-row>
				
			</el-form>
			
			<div class="wrap" v-if="id">
				
				<div class="left">
					<div class="left_title">一、单选题</div>
					<div class="left_item" v-for="(item,index) in danxuan" :key="index+'d'">
						<div class="left_item_title">
							<div>{{Number(index)+1}}、{{item.question_title}}</div>
							<!-- <img src="../../assets/img/bian.png" alt="" @click="bian()"> -->
							<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.id)">
						</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item" :class="ite.is_yes == 1?'left_item_btm_itemac':''" 
							v-for="ite in item.option">{{ite.option_sn}}、{{ite.option_title}}</div>
						</div>
					</div>
					<div class="left_title" style="margin-top: 50px;">二、多选题</div>
					<div class="left_item" v-for="(item,index) in duoxuan" :key="index+'c'">
						<div class="left_item_title">
							<div>{{Number(index)+1}}、{{item.question_title}}</div>
							<!-- <img src="../../assets/img/bian.png" alt=""> -->
							<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.id)">
						</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item" :class="ite.is_yes == 1?'left_item_btm_itemac':''" 
							v-for="ite in item.option">{{ite.option_sn}}、{{ite.option_title}}</div>
						</div>
					</div>
					<div class="left_title" style="margin-top: 50px;">三、判断题</div>
					<div class="left_item" v-for="(item,index) in panduan" :key="index+'b'">
						<div class="left_item_title">
							<div>{{Number(index)+1}}、{{item.question_title}}</div>
							<!-- <img src="../../assets/img/bian.png" alt=""> -->
							<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.id)">
						</div>
						<div class="left_item_btm">
							<div class="left_item_btm_item" :class="ite.is_yes == 1?'left_item_btm_itemac':''" 
							v-for="ite in item.option">{{ite.option_sn}}、{{ite.option_title}}</div>
						</div>
					</div>
					<div class="left_title" style="margin-top: 50px;">四、简答题</div>
					<div class="left_item" v-for="(item,index) in yingyiong" :key="index+'a'">
						<div class="left_item_title">
							<div>{{Number(index)+1}}、{{item.question_title}}</div>
							<!-- <img src="../../assets/img/bian.png" alt=""> -->
							<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.id)">
						</div>
						<el-input style="margin-top: 20px;" v-model="item.answer.answer" readonly type="textarea" clearable :rows="6"/>
					</div>
				</div>
				
			</div>
		</div>
	
		<!-- 试题列表 -->
		<el-dialog title="添加试题" :visible.sync="open" width="1024px" append-to-body>
		   	<el-form  ref="form" style="width: 100%;" :model="form" label-width="80px">
		   		<el-row>
		   		  <el-col :span="9">
		   		    <el-form-item label="试题名称">
		   		      <el-input style="width: 230px;" v-model="form.keywords" placeholder="请输入试题名称" type="text"/>
		   		    </el-form-item>
		   		  </el-col>
		   		  <el-col :span="9">
		   		    <el-form-item label="试题类型">
		   		     <el-select  style="width: 230px;" v-model="form.question_type" placeholder="请选择试题类型">
		   		        <el-option
							v-for="item in selist"
							:key="item.id"
							:label="item.title"
							:value="item.id">
		   		        </el-option>
		   		     </el-select>
		   		    </el-form-item>
		   		  </el-col>
		   		  <el-button icon="el-icon-search" type="primary" @click="select_task_question()">搜索</el-button>
		   		</el-row>
		   	</el-form>
		   <el-table style="width: 100%;margin-top: 38px;" border :data="tableData" 
		   :header-cell-style="{background: '#F5F6F7'}"  @selection-change="handleSelectionChange">
			   <el-table-column type="selection" width="55" align="center" />
			   <el-table-column prop="id" label="ID" width="55" align="center"/>
			   <el-table-column prop="question_title" label="试题名称" width="300" align="center"/>
			   <el-table-column label="试题类型" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.question_type == 1">单选</span>
					<span v-if="scope.row.question_type == 2">多选</span>
					<span v-if="scope.row.question_type == 3">判断</span>
					<span v-if="scope.row.question_type == 4">应用</span>
				</template>
			   </el-table-column>
			   <el-table-column prop="kecheng_name" label="课程名称" align="center"/>
			   <el-table-column prop="add_time" label="添加时间" align="center"/>
		   </el-table>
		   <div class="block" style="margin-top: 20px;text-align: center;">
		   	<el-pagination background layout="prev, pager, next"  
		   	@current-change="handleCurrentChange" :current-page="currentPage" :total="total"></el-pagination>
		   </div>
		   <div slot="footer" class="dialog-footer" style="text-align: center;">
		     <el-button @click="cancel">取 消</el-button>
			 <el-button type="primary" @click="submitForm">确 定</el-button>
		   </div>
		</el-dialog>
	</div>
</template>
<script>
import {task_details,add_task,edit_task,select_task_question,add_task_question,task_question_list,delete_task_quest} from "../../api/new.js";	
	export default {
		data() {
			return {
				open:false,
				loading: false,
				tableData:[],
				form:{
					page:1,
					limit:10,
					keywords:'',
					task_id:'',
					question_type:'',
				},
				pageSizes: [10, 50, 100, 200],
				pageSize: 10,
				total: 0,
				currentPage: 1,
				id:'',
				selist:[{id:1,title:'单选'},{id:2,title:'多选'},{id:3,title:'判断'},{id:4,title:'应用'},{id:5,title:'全部'}],
				queryParams:{
					kecheng_id:'',
					task_name:'',
					task_danxuan_code:'',
					task_duoxuan_code:'',
					task_panduan_code:'',
					task_yingyong_code:'',
				},
				shiti:[],
				danxuan:[],
				duoxuan:[],
				panduan:[],
				yingyiong:[],
			};
		},
		mounted() {
			this.queryParams.kecheng_id = this.$route.query.kecheng_id
			if(this.$route.query.id){
				this.id = this.$route.query.id
				this.form.task_id = this.$route.query.id
				this.task_details()
				this.task_question_list()
			}
		},
		methods: {
			//删除试题
			delquestion(id){
				var _this = this
				var data = { id:id }
				this.$confirm('您确定要删除试题吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					delete_task_quest(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.task_question_list()
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}).catch(() => {});
			},
			//作业详情
			task_details(){
				var _this = this
				var data = {id:this.id}
				task_details(data).then((res) => {
					if (res.code == 0) {
						this.queryParams = res.data
					} else {
						this.$message.error(res.msg);
					} 
				})
			},
			//试题列表
			task_question_list(){
				var _this = this
				var data = {id:this.id}
				task_question_list(data).then((res) => {
					if (res.code == 0) {
						this.shiti = res.data
						this.danxuan = res.data.danxuan.danxuan_list
						this.duoxuan = res.data.duoxuan.duoxuan_list
						this.panduan = res.data.panduan.panduan_list
						this.yingyiong = res.data.yingyiong.yingyiong_list
					} else {
						this.$message.error(res.msg);
					} 
				})
			},
			//选择未加入作业的试题的列表
			select_task_question(){
				var _this = this
				this.loading = true
				select_task_question(this.form).then((res) => {
					this.loading = false
					if (res.code == 0) {
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.msg);
					} 
				})
				.catch((err) => {
					this.loading = false
				});	
			},
			//创建，编辑作业
			taskbian(){
				var _this = this
				if(this.id){
					//修改
					edit_task(this.queryParams).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.task_details()
						} else {
							_this.$message.error(res.msg);
						}
					})
				}else{
					// 新增
					add_task(this.queryParams).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							setTimeout(function(){
								_this.back()
							},1000)
						} else {
							_this.$message.error(res.msg);
						}
					})
				}
			},
			back(){
				this.$router.back()
			},
			//添加试题
			submitForm(){
				var _this = this
				if(this.ids.length > 0){
					var idd = this.ids.toString()
					var data = {
						id:this.id,
						question_id:idd,
					}
					add_task_question(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.open = false
							_this.task_question_list()
						} else {
							this.$message.error(res.msg);
						} 
					})
				}
			},
			cancel(){
				this.open = false
			},
			//打开弹窗
			opendio(){
				this.open = true
				this.select_task_question()
			},
			bian(){
				this.$router.push({
				  path: "/tiku",
				  query: {
				    id: "1",
				  },
				});
			},
			// 多选框选中数据
			handleSelectionChange(selection) {
				this.ids = selection.map(item => item.id)
			},
			//未选中试题列表上一页，下一页
			handleCurrentChange(currentPage) {
				this.form.page = currentPage;
				this.currentPage = currentPage;
				this.select_task_question()
			}
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	margin: 0 auto;
	.info{
		width: 100%;
		background: #FFFFFF;
		border-radius: 20px;
		padding: 40px 100px 40px 50px;	
		.back{
			width: 80px;
			display: flex;
			align-items: center;
			cursor: pointer;
			margin-bottom: 20px;
			img{
				width: 26px;
				height: 26px;
				margin-right: 8px;
			}
			div{
				font-size: 20px;
				font-weight: bold;
				color: #333333;
				line-height: 20px;
			}
		}
		.info_title{
			width: 100%;
			font-size: 30px;
			font-weight: 500;
			color: #333333;
			font-weight: bold;
			line-height: 30px;
			text-align: center;
		}
		.wrap{
			width: 100%;
			display: flex;
			justify-content: space-between;
			margin-top: 40px;
			.left{
				flex: 1;
				.left_title{
					width: 100%;
					font-size: 18px;
					font-weight: 500;
					color: #333333;
					line-height: 36px;
				}
				.left_item{
					width: 100%;
					margin-top: 20px;
					.left_item_title{
						width: 100%;
						display: flex;
						justify-content: space-between;
						div{
							flex: 1;
							font-size: 18px;
							font-weight: 500;
							color: #333333;
							line-height: 36px;
						}
						img{
							width: 30px;
							height: 30px;
							margin-left: 20px;
							cursor: pointer;
						}
					}
					.left_item_btm{
						width: 80%;
						display: flex;
						flex-wrap: wrap;
						padding-left: 25px;
						.left_item_btm_item{
							margin-top: 15px;
							margin-right: 25px;
							font-size: 18px;
						}
						.left_item_btm_itemac{
							color: #007AFF;
						}
					}
					
				}
				
			}
			.right{
				width: 265px;
				margin-right: 80px;
				.zujuan{
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.zujuan_btn{
						width: 120px;
						height: 48px;
						background: #FAB337;
						border-radius: 10px;
						font-size: 18px;
						color: #FFFFFF;
						line-height: 48px;
						text-align: center;
						// margin: 0 20px;
						cursor: pointer;
					}
					.zujuan_btn1{
						background: #E81E6F;
					}
					.zujuan_btn:hover{
						opacity: 0.7;
					}
					.zujuan_btn:active{
						opacity: 0.9;
					}
				}
				.right_title{
					font-size: 20px;
					font-weight: bold;
					color: #333333;
					line-height: 20px;
				}
				.right_title1{
					font-size: 18px;
					font-weight: 500;
					color: #333333;
					line-height: 18px;
					margin-top: 18px;
				}
				.right_box{
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					.right_box_item{
						width: 38px;
						height: 38px;
						border: 2px solid #CCCCCC;
						border-radius: 50%;
						font-size: 20px;
						color: #666666;
						line-height: 34px;
						text-align: center;
						margin-top: 13px;
						margin-right: 17px;
						cursor: default;
					}
					.right_box_item:nth-child(5n+5){
						margin-right: 0;
					}
				}
				.status{
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 26px 0;
					margin-top: 26px;
					border-top: 1px solid #E6E6E6;
					.status_item{
						display: flex;
						align-items: center;
						cursor: default;
						.status_item_dian{
							width: 20px;
							height: 20px;
							background: #40D497;
							border-radius: 50%;
							margin-right: 10px;
						}
						.status_item_dian1{
							width: 20px;
							height: 20px;
							background: #D8D8D8;
							border-radius: 50%;
							margin-right: 10px;
						}
						.status_item_title{
							font-size: 20px;
							font-weight: 500;
							color: #656565;
							line-height: 20px;
						}
					}
				}
				.submit{
					width: 100%;
					height: 56px;
					background: #007AFF;
					border-radius: 28px;
					font-size: 20px;
					font-weight: 500;
					color: #FFFFFF;
					line-height: 56px;
					text-align: center;
					cursor: pointer;
					margin-top: 20px;
				}
				.submit:hover{
					opacity: 0.7;
				}
				.submit:active{
					opacity: 0.9;
				}
			}
			
		}
	
	
	
	}
	.zujuan_btn{
		width: 140px;
		height: 44px;
		background: #4076F3;
		border-radius: 10px;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 44px;
		text-align: center;
		cursor: pointer;
		margin-left: 35px;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
	}
	.btn1{
		background: #ED7F26;
	}
	.btn2{
		background: #E13049;
	}
	.zujuan_btn:hover{
		opacity: 0.7;
	}
	.zujuan_btn:active{
		opacity: 0.9;
	}
	.el-radio {
		margin-top: 15px;
		margin-left: 15px;
	}
	.el-checkbox{
		margin-top: 15px;
		margin-left: 15px;
	}
	.xiubtm{
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 50px 0 80px 0;
		.nice1 {
			width: 140px;
			height: 52px;
			background: #007AFF;
			border-radius: 25px;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 52px;
			text-align: center;
			cursor: pointer;
		}
		
		.nice1:hover {
			opacity: 0.7;
		}
		
		.nice1:active {
			opacity: 0.9;
		}
		.noo{
			background: #E6E6E6;
			color: #333333;
			margin-right: 44px;
		}
	}
}	
</style>



// WEBPACK FOOTER //
// src/components/zuoye/addZuo.vue